import { render, staticRenderFns } from "./WabaAnalys.vue?vue&type=template&id=5521cc30&scoped=true"
import script from "./WabaAnalys.vue?vue&type=script&lang=js"
export * from "./WabaAnalys.vue?vue&type=script&lang=js"
import style0 from "./WabaAnalys.vue?vue&type=style&index=0&id=5521cc30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521cc30",
  null
  
)

export default component.exports